import React, { useState, useEffect, Fragment, useRef } from "react";
import { ApiCall, Colors, Web_url } from "../../common/Const";
import { images } from "../../common/Images";
import String from "../../lang/String";
import "../../styles/styles.css";
import EncryptDecrypt from "../../common/Crypto";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import store from "../../redux/Store";
import Badge from "@mui/material/Badge";
import { Dropdown } from "antd";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "@mui/material/Modal";
import SearchCom from "./SearchCom";
import CateCom from "./CateCom";
import $ from "jquery";
import tm from "../../assets/tm.png"
function Header(props) {
  const [show, setshow] = useState(true);
  const { display, make } = props;
  const RdxCate = useSelector((state) => state.HdCat.value);
  const fav = useSelector((state) => state.favCount);
  const offer = useSelector((state) => state.offerCount);


  const [Category, setCategory] = useState(
    RdxCate && Object.keys(RdxCate).length > 0 && RdxCate.data.length > 0
      ? RdxCate
      : []
  );
  const [cusId, setcusId] = useState(0);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [LocalValue, setLocalValue] = useState(0);
  const [SearchVal, setSearchVal] = useState("");
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const RdxMenu = useSelector((state) => state.menu.value);
  const params = useSelector((state) => state.params);
  const { searchVal } = params;
  const [modelOpen, setmodelOpen] = useState(false);

  const DecryptData = async () => {
    let type = "decrypt";
    let format = "text";
    let id = localStorage.getItem("customerId");
    await EncryptDecrypt(id, type, format, (response) => {
      setcusId(response);
    });
  };

  const Redxcart = useSelector((state) => state.cart);

  const CusName = localStorage.getItem("first_name");
  useEffect(() => {
    // if (RdxCate == undefined) {
      homeSection();
    // }
  }, [cusId]);

  useEffect(() => {
    if (user && user.id > 0) {
      favCount();
      offerCount();
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("customerId") != null) {
      setLocalValue(localStorage.getItem("customerId"));
    }
  }, [localStorage.getItem("customerId")]);

  useEffect(() => {
    DecryptData();

    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const homeSection = () => {
    ApiCall("homeSection", {})
      .then((data) => {
        if (data.message == "Success") {
          console.log(data.result[6],"data.result[6]data.result[6]")
          setCategory(data.result[6]);
          store.dispatch({ type: "setCate", payload: data.result[6] });
        }
      })
      .catch((err) => console.log(err));
  };

  const callSearchFilter = () => {
    if (SearchVal != "") {
      store.dispatch({ type: "setSearchparams", payload: SearchVal });
      if (make) {
        navigate("/filter");
      }
      {
        props.reload(Math.random().toString(36).slice(2, 7));
      }
    }
  };

  const goToCart = () => {
    navigate("/mycart");
  };

  const callFilter = (catid) => {
    store.dispatch({ type: "setCatparams", payload: catid });
    if (make) {
      navigate("/filter");
    }
    {
      props.reload(Math.random().toString(36).slice(2, 7));
    }
    if (windowSize < 989) {
      $(".navbar-toggler").click();
    }
  };

  const onEnterFun = (e) => {
    if (e.key === "Enter") {
      callSearchFilter();
    }
  };

  const srchRef = useRef();

  const clearSearch = () => {
    srchRef.current.value = "";
    setSearchVal("");
    store.dispatch({ type: "ClearMenu" });
    store.dispatch({ type: "ClearParams" });
    store.dispatch({ type: "ClearSort" });
    props.reRes(Math.random().toString(36).slice(2, 7));
  };

  const handleLogOut = () => {
    const logoutParams = { customer_id: user.id ,type:"web"};

    ApiCall("auth/logout", logoutParams)
      .then((data) => {
        if (data.message == "Success.") {
          store.dispatch({ type: "logout" });
          store.dispatch({ type: "removeData" });
          store.dispatch({ type: "clearCart" });
          localStorage.clear();
          sessionStorage.removeItem("viewedProducts");

          toast.success("Logged out succesfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate("/");
        } else {
          toast.error(data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((err) => console.log(err));
    handleCloseModel();
  };
  const offerCount = () => {
    const params = {
      customer_id: user.id,
    };

    ApiCall("getNotification", params)
      .then((data) => {
        if (data.message ==="Notifications listed successfully.") {
          store.dispatch({
            type: "addOfferCount",
            payload: data.total_count,
          });
        }
        else{
          store.dispatch({
            type: "addOfferCount",
            payload: 0,
          });
        }
      })
      .catch((err) => console.log(err));
  };
  const favCount = () => {
    const params = {
      customer_id: user.id,
      page_number: 0,
    };

    ApiCall("favView", params)
      .then((data) => {
        if (data.message == "Success.") {
          store.dispatch({
            type: "addfavCount",
            payload: data.fav_total_count,
          });
        }
      })
      .catch((err) => console.log(err));
  };
  const items = [
    {
      key: "1",
      label: (
        <div>
          <i
            style={{
              color: "white",
              backgroundColor: Colors.Base_color,
              borderRadius: "50%",
            }}
            class="fa-regular fa-user p-2"
          ></i>
          <a
            className="drp-menu mx-2"
            style={{ color: "#000", fontWeight: "500" }}
            rel="noopener noreferrer"
            href="/myprofile"
          >
            My Profile
          </a>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={() => setmodelOpen(!modelOpen)}>
          <i
            style={{
              color: "white",
              backgroundColor: Colors.Base_color,
              borderRadius: "50%",
            }}
            class="fa-solid fa-right-from-bracket p-2"
          ></i>
          <span
            className="drp-menu mx-2"
            style={{ color: "#000", fontWeight: "500" }}
          >
            Logout
          </span>
        </div>
      ),
    },
  ];
  const handleCloseModel = () => {
    setmodelOpen(!modelOpen);
  };
  const LoginData = useSelector((state) => state.login);
  return (
    <Fragment>
      <div
        className="header-box"
        style={{ position: "sticky", top: 0, zIndex: 900, transition: "5s" }}
      >
        <nav
          className="navbar navbar-expand-lg cs-color "
          style={{ backgroundColor: Colors.white_color }}
        >
          <div
            className={
              windowSize <= 500
                ? "container-fluid px-2"
                : "container-fluid px-5 "
            }
          >
            <div style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              gap:'10px'
            }}>
          <img
            role={"button"}
            className="hdr-logo"
            src={images.Hlogo}
            // width="200"
            // height="80"
            alt="user"
            onClick={() => {navigate("/")
            window.scrollTo({ top: 0, behavior: "smooth" })}}
            style={{
              width: windowSize >= 500 ? '250px' : '100px',
              height: windowSize >= 500 ? '80px' : '40px',
              objectFit:'contain'
            }}
          />
          {/* {
             windowSize >= 500 && 
          <div 
          style={{
            cursor:'pointer',
            position: 'relative'
          }}
            onClick={() => {navigate("/")
            window.scrollTo({ top: 0, behavior: "smooth" })}}>
          <p style={{
            margin:0,
            padding:0,
            fontSize:'20px',
            color:Colors.Base_color
          }}>Theni </p>
          <p style={{
            margin:0,
            padding:0,
            fontSize:'20px',
            color:Colors.Base_color
          }}>Kamadhenu</p>
          </div>
          } */}
          </div>
            <div style={{
              flexDirection: 'row',
              display: 'flex',
              width: windowSize >= 500 ? '100%' : 'auto',
              justifyContent: 'flex-end'
            }}>

            <SearchCom
                    display={display}
                    setSearchVal={setSearchVal}
                    searchVal={searchVal}
                    clearSearch={clearSearch}
                    callSearchFilter={callSearchFilter}
                    onEnterFun={onEnterFun}
                    srchRef={srchRef}
                  />
</div>
            {user && user.id > 0 ? (
              // {(user && user.id > 0) || LocalValue != 0 ? (
              <div
                className={
                  windowSize < 500
                    ? "d-flex flex-row justify-content-center align-items-center"
                    : "d-none"
                }
                style={{
                  gap:'3px'
                }}
              >
                {
                  user && user.avatar && user.avatar != "" ? 
                  <img
                    role={"button"}
                    style={{ objectFit: "cover" }}
                    className="sm-img-hr rounded-circle"
                    src={ Web_url.Domain_url + user.avatar 
                    }
                    width="50"
                    height="50"
                    alt="user"
                    onClick={() => navigate("/myprofile")}
                  /> :<>
                    <div 
                    onClick={() => navigate("/myprofile")} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '25px',
                      height: '25px', }}>
                  <i class="fa-solid fa-user" style={{
                      position: 'relative',
                      color: 'white',
                      fontSize:'13px'}}>
                    </i></div>
                    
                    </>
                }
                <div className="d-flex flex-column mx-1">
                  {CusName && CusName != "" && (
                    <span
                      className="font-weight-bold sm-hdr-head text-capitalize"
                      style={{ color: "#126a38" }}
                      onClick={() => navigate("/myprofile")}
                    >
                      {CusName}
                      {/* {CusName && CusName != "" ? CusName : String.header_text.customer_name} */}
                      {/* {user && user.first_name != "" ? (user.first_name + (user.last_name != "" ? user.last_name: '')) : String.header_text.customer_name} */}
                    </span>
                  )}

                  <small
                    className="sm-hdr-text"
                    onClick={() => navigate("/myprofile")}
                  >
                    Profile
                  </small>
                  {/* <small className="sm-hdr-text">
          {String.header_text.customer_id}: #{cusId && cusId > 0 ? cusId : '1605'} */}
                  {/* {String.header_text.customer_id}: #{user && user.id > 0 ? user.id : '1605'} */}
                  {/* </small> */}
                </div>
                <div  onClick={goToCart} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '25px',
                      height: '25px', }}>
                  <i class="fa-solid fa-bag-shopping" style={{
                      position: 'relative',
                      color: 'white',
                      fontSize:'13px'}}>
                    </i>
                  <Badge
                    badgeContent={Redxcart.length}
                    color={"warning"}
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.7rem", // Adjust the font size
                        height: "12px", // Adjust the height of the badge
                        minWidth: "12px", // Adjust the minimum width of the badge
                        width: "12px", // Adjust the minimum width of the badge
                        padding: "4px", // Adjust padding for better visuals
                      },
                    }}
                    style={{ position: "absolute", top: 0, right: 5 }}
                  ></Badge>
                  {/* <img
                    className="sm-img-hr rounded-circle"
                    src={images.headerbag}
                    width="50"
                    height="50"
                    alt="user"
                    onClick={goToCart}
                    role={"button"}
                  /> */}
                </div>
                <div onClick={() => navigate("/notifications")} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '25px',
                      height: '25px', }}>
                  <i class="fa-solid fa-percent" style={{
                      position: 'relative',
                      color: 'white',
                      fontSize:'13px'}}>
                    </i>
                  <Badge
                        badgeContent={offer.total_count}
                    color={"warning"}
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.7rem", // Adjust the font size
                        height: "12px", // Adjust the height of the badge
                        minWidth: "12px", // Adjust the minimum width of the badge
                        width: "12px", // Adjust the minimum width of the badge
                        padding: "4px", // Adjust padding for better visuals
                      },
                    }}
                    style={{ position: "absolute", top: 0, right: 5 }}
                  ></Badge>
                      {/* <img
                        src={images.offer}
                        width="30"
                        height="30"
                        alt="user"
                        className="rounded-circle"
                        role={"button"}
                        onClick={() => navigate("/notifications")}
                      /> */}
                    </div>
                    <div onClick={() => navigate("/wishlist")} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '25px',
                      height: '25px', }}>
                  <i class="fa-solid fa-heart" style={{
                      position: 'relative',
                      color: 'white',
                      fontSize:'13px'}}>
                    </i>
                    
                  <Badge
                    badgeContent={fav.qty}
                    color={"warning"}
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.7rem", // Adjust the font size
                        maxHeight: "12px", // Adjust the height of the badge
                        minWidth: "12px", // Adjust the minimum width of the badge
                        width: "12px", // Adjust the minimum width of the badge
                        padding: "4px", // Adjust padding for better visuals
                      },
                    }}
                    style={{ position: "absolute", top: 0, right: 5 }}
                  ></Badge>
                  {/* <img
                    src={images.headerHeart}
                    width="50"
                    height="50"
                    alt="user"
                    className="sm-img-hr rounded-circle"
                    role={"button"}
                    onClick={() => navigate("/wishlist")}
                  /> */}
                </div>
                {/* <i title="Home" class="fa-solid fa-house m-1 rounded-circle" style={{color: '#fff' ,backgroundColor: Colors.Base_color, fontSize: '15px', padding: '7px'}}></i> */}
                {/* <img
                  src={images.homeIcon}
                  width="50"
                  height="50"
                  alt="user"
                  className="sm-img-hr rounded-circle mx-1"
                  role={"button"}
                  onClick={() => {
                    navigate("/");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                /> */}
                <div style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '25px',
                      height: '25px', }}>
                  <i class="fa-solid fa-house" style={{
                      position: 'relative',
                      color: 'white',
                      fontSize:'13px'}}>
                    </i>
                    </div>
                <button
                  className="navbar-toggler border"
                  onClick={() => {
                    setshow(!show);
                  }}
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
              </div>
            ) : (
              <div>
                <button
                  type="button"
                  class="btn btn-sm signup-btn py-1 px-2 rounded"
                  onClick={() => navigate("/register")}
                  style={{
                    backgroundColor: Colors.Base_color,
                    color: Colors.white_color,
                  }}
                >
                  {String.header_text.sign_up}
                </button>
                <button
                  type="button"
                  class="btn login-btn py-1 px-2 rounded mx-2"
                  style={{
                    color: Colors.Base_color,
                    backgroundColor: Colors.white_color,
                    border: `1px solid ${Colors.Base_color}`,
                  }}
                  onClick={() => navigate("/login")}
                >
                  {String.header_text.login}
                </button>
                <button
                  className="navbar-toggler border"
                  onClick={() => {
                    setshow(!show);
                  }}
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
              </div>
            )}

            <div
              className={
                show
                  ? "collapse navbar-collapse"
                  : "collapse navbar-collapse active"
              }
              style={{
                width:'100%'
              }}
            >
              <ul
                className="navbar-nav ms-auto drop-ui my-2"
                // style={{backgroundColor: Colors.Base_color, color: Colors.white_color}}
              style={{
                gap:10
              }}
              >
                {user && user.id > 0 ? (
                  // {(user && user.id > 0) || LocalValue != 0 ? (
                  <div
                    className={
                      windowSize > 500
                        ? "user-info d-flex flex-row justify-content-center align-items-center"
                        : "d-none"
                    }
                    style={{
                      gap:10
                    }}
                  >
                    {!LoginData.id ? null : LoginData.userType == 0 ? (
                      <Dropdown
                        menu={{
                          items,
                        }}
                      >
                        <div className="d-flex flex-column align-items-center justify-cont">
                          {
                            user && user.avatar && user.avatar != "" ? 
                            <img
                              src={ Web_url.Domain_url + user.avatar
                              }
                              width="65"
                              height="65"
                              alt="user"
                              className="rounded-circle"
                              style={{ objectFit: "cover" }}
                              role={"button"}
                              onClick={() => navigate("/myprofile")}
                            /> : <>
                             <div 
                    onClick={() => navigate("/myprofile")} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '50px',
                             cursor:'pointer',
                      height: '50px', }}>
                  <i class="fa-solid fa-user" style={{
                      position: 'relative',
                      color: 'white',
                      fontSize:'25px'}}>
                    </i>
                    </div>
                    {/* <span className="header-menu-name " style={{
                      opacity:0
                    }}>Cart</span> */}
                    </>
                          }
                        </div>
                      </Dropdown>
                    ) : null}
                    <div className="d-flex flex-column mx-1">
                      {/* <span
                 className="fw-bold"
                 style={{ color: "#126a38" }}
               >
                {CusName && CusName != "" ? CusName : String.header_text.customer_name} */}
                      {/* {user && user.first_name != "" ? (user.first_name +" "+ (user.last_name != "" ? user.last_name: '')) : String.header_text.customer_name} */}
                      {/* </span> */}
                      {CusName && CusName != "" && (
                        <span
                          className="font-weight-bold sm-hdr-head text-capitalize"
                          style={{ color: "#126a38" }}
                          role="button"
                          onClick={() => navigate("/myprofile")}
                        >
                          {CusName}
                          {/* {CusName && CusName != "" ? CusName : String.header_text.customer_name} */}
                          {/* {user && user.first_name != "" ? (user.first_name + (user.last_name != "" ? user.last_name: '')) : String.header_text.customer_name} */}
                        </span>
                      )}
                      <small
                        className="hdr-sm"
                        role={"button"}
                        onClick={() => navigate("/myprofile")}
                        style={{ lineHeight: "1" }}
                      >
                        Profile
                      </small>
                      {/* <small className="hdr-sm">
                {String.header_text.customer_id}: #{cusId && cusId > 0 ? cusId : '1605'} */}
                      {/* {String.header_text.customer_id}: #{user && user.id > 0 ? user.id : '1605'} */}

                      {/* </small> */}
                    </div>
                    {/* <p>{user.id + LocalValue}</p> */}

                    <div style={{ position: "relative",justifyItems: 'center' }}>
                    <div onClick={goToCart} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '50px',
                      height: '50px', }}>
                      <Badge
                        badgeContent={Redxcart.length}
                        color="warning"
                        style={{ position: "absolute", top: 6, right: 6 }}
                      ></Badge>
                    <i class="fa-solid fa-bag-shopping" style={{
                        position: 'relative',
                        color: 'white',
                        fontSize:'25px'}}>
                      </i>
                    </div>
                      <span className="header-menu-name ">Cart</span>
                    </div>

                    <div style={{ position: "relative",justifyItems: 'center' }}>
                    <div onClick={() => navigate("/notifications")} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '50px',
                      height: '50px', }}>
                      <Badge
                        badgeContent={offer.total_count}
                        color="warning"
                        style={{ position: "absolute", top: 6, right: 6 }}
                      ></Badge>
                    <i class="fa-solid fa-percent" style={{
                        position: 'relative',
                        color: 'white',
                        fontSize:'25px'}}>
                      </i>
                    </div>
                      <span className="header-menu-name ">Offer</span>
                    </div>

                    {/* <div style={{ position: "relative" }} role={"button"} onClick={() => navigate("/notifications")}>
                      <Badge
                        badgeContent={offer.total_count}
                        color="secondary"
                        style={{ position: "absolute", top: 12, right: 16 }}
                      ></Badge>
                      <img
                        src={images.offer}
                        width="65"
                        height="65"
                        alt="user"
                        className="rounded-circle offer-header-img"
                      />
                      <br></br>
                      <span className="mx-3 header-menu-name">Offer</span>
                    </div> */}


                    <div style={{ position: "relative",justifyItems: 'center' }}>
                      <div onClick={() => navigate("/wishlist")} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '50px',
                        height: '50px', }}>
                        <Badge
                        badgeContent={fav.qty}
                          color="warning"
                          style={{ position: "absolute", top: 6, right: 6 }}
                        ></Badge>
                      <i class="fa-solid fa-heart" style={{
                          position: 'relative',
                          color: 'white',
                          fontSize:'25px'}}>
                        </i>
                      </div>
                      <span className="header-menu-name ">Wishlist</span>
                    </div>

                    {/* <div style={{ position: "relative" }} role={"button"} onClick={() => navigate("/wishlist")}>
                      <Badge
                        badgeContent={fav.qty}
                        color="secondary"
                        style={{ position: "absolute", top: 12, right: 16 }}
                      ></Badge>
                      <img
                        src={images.headerHeart}
                        width="65"
                        height="65"
                        alt="user"
                        className="rounded-circle"
                      />
                      <br></br>
                      <span className="mx-2 header-menu-name">Wishlist</span>
                    </div> */}

                    <div style={{ position: "relative",justifyItems: 'center' }}>
                      <div onClick={() => {
                        navigate("/");
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '50px',
                        height: '50px', }}>
                        {/* <Badge
                        badgeContent={fav.qty}
                          color="warning"
                          style={{ position: "absolute", top: 6, right: 6 }}
                        ></Badge> */}
                      <i class="fa-solid fa-home" style={{
                          position: 'relative',
                          color: 'white',
                          fontSize:'25px'}}>
                        </i>
                      </div>
                      <span className="header-menu-name ">Home</span>
                    </div>

                    {/* <div role={"button"} onClick={() => {
                        navigate("/");
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}>
                    <img
                      src={images.homeIcon}
                      width="65"
                      height="65"
                      alt="user"
                      className="rounded-circle mx-1"
                    />
                    <br></br>
                      <span className="mx-3 header-menu-name">Home</span>
                    </div> */}

                    {/* <i title="Home" class="fa-solid fa-house m-1 rounded-circle" style={{color: '#fff' ,backgroundColor: Colors.Base_color, fontSize: '24px', padding: '14px'}}></i> */}
                  </div>
                ) : (
                  <>
                    {/* <li className="nav-item d-flex align-items-center justify-content-center"><i class="fa-solid fa-house" style={{color: Colors.Base_color, fontSize: '24px'}}></i></li> */}
                    <li className="nav-item d-flex align-items-center" style={{
                      gap:10
                    }}>

                    <div style={{ position: "relative",justifyItems: 'center' }}>
                      <div onClick={() => {
                        navigate("/");
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '50px',
                        height: '50px', }}>
                      <i class="fa-solid fa-home" style={{
                          position: 'relative',
                          color: 'white',
                          fontSize:'25px'}}>
                        </i>
                      </div>
                      <span className="header-menu-name ">Home</span>
                    </div>
                    
                    <div style={{ position: "relative",justifyItems: 'center' }}>
                    <div onClick={goToCart} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '50px',
                      height: '50px', }}>
                      <Badge
                        badgeContent={Redxcart.length}
                        color="warning"
                        style={{ position: "absolute", top: 6, right: 6 }}
                      ></Badge>
                    <i class="fa-solid fa-bag-shopping" style={{
                        position: 'relative',
                        color: 'white',
                        fontSize:'25px'}}>
                      </i>
                    </div>
                      <span className="header-menu-name ">Cart</span>
                    </div>
                    <div style={{ position: "relative",justifyItems: 'center' }}>
                    <div onClick={() => navigate("/wishlist")} style={{ position: "relative",textAlign: 'center', alignContent: 'center' ,backgroundColor : Colors.Base_color,borderRadius:'50%', width: '50px',
                      height: '50px', }}>
                  <i class="fa-solid fa-heart" style={{
                      position: 'relative',
                      color: 'white',
                      fontSize:'25px'}}>
                    </i>
                    
                  <Badge
                    badgeContent={fav.qty}
                    color={"warning"}
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.7rem", // Adjust the font size
                        maxHeight: "12px", // Adjust the height of the badge
                        minWidth: "12px", // Adjust the minimum width of the badge
                        width: "12px", // Adjust the minimum width of the badge
                        padding: "4px", // Adjust padding for better visuals
                      },
                    }}
                    style={{ position: "absolute", top: 0, right: 5 }}
                  ></Badge>
                </div>
                <span className="header-menu-name ">Wishlist</span>
                </div>

                    {/* <div role={"button"} onClick={() => {
                          navigate("/");
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}>
                      <img
                        src={images.homeIcon}
                        width="65"
                        height="65"
                        alt="user"
                        className="rounded-circle"
                      />
                      <br></br>
                      <span className="mx-2 header-menu-name">Home</span>
                      </div> */}
                      {/* <div role={"button"} onClick={goToCart}>
                      <img
                        src={images.headerbag}
                        width="65"
                        height="65"
                        alt="user"
                        className="rounded-circle mx-2"
                        style={{ marginRight: "3px" }}
                      />
                       <br></br>
                      <span className="mx-4 header-menu-name">Cart</span>
                      </div> */}
                    </li>
                    {/* <li className="nav-item">
                      <img
                        src={images.headerbag}
                        onClick={goToCart}
                        width="65"
                        height="65"
                        alt="user"
                        className="rounded-circle"
                        role={"button"}
                        style={{marginRight: '3px'}}
                      />
                    </li> */}
                    <li className="nav-item" style={{ alignSelf: "center" }}>
                      <button
                        type="button"
                        class="btn btn-danger spl-btn-1 py-1 px-4 rounded"
                        style={{ backgroundColor: Colors.Base_color,border: 'none !important;',    border: 'white' }}
                        onClick={() => navigate("/register")}
                      >
                        {String.header_text.sign_up}
                      </button>
                    </li>
                    <li className="nav-item" style={{ alignSelf: "center" }}>
                      <button
                        type="button"
                        class="btn spl-btn-2 py-1 px-4 rounded mx-2"
                        style={{
                          color: Colors.Base_color,
                          backgroundColor: Colors.white_color,
                          border: `1px solid ${Colors.Base_color}`,
                        }}
                        onClick={() => navigate("/login")}
                      >
                        {String.header_text.login}
                      </button>
                    </li>
                  </>
                )}

                {Category.data &&
                  Category.data.length > 0 &&
                  Category.data.map((data) => {
                    return (
                      <Fragment key={data.id}>
                        <span
                          className="nav-item head-category my-2"
                          onClick={() => callFilter(data.id)}
                        >
                          {data.category_name}
                        </span>
                      </Fragment>
                    );
                  })}

                {/* {Category.data && Category.data.length > 0 && (Category.data.map((data) => {
          return <Fragment key={data.id}> <p style={{color: Colors.white_color}} onClick={() => callFilter(data.id)}>{data.category_name}</p> </Fragment>;
        })
    )} */}
              </ul>
            </div>
          </div>
        </nav>
        {/* {showTop && (
    <Fragment> */}

        {/* </Fragment>
  ) } */}
        <Modal
          open={modelOpen}
          onClose={handleCloseModel}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            outline: "none",
          }}
        >
          <div
            className="d-flex justify-content-center align-items"
            style={{ width: "70%", border: "none", outline: "none" }}
          >
            <div
              className="d-flex flex-column"
              style={{
                width: windowSize > 512 ? "50%" : "95%",
                backgroundColor: "#fff",
              }}
            >
              <i
                onClick={handleCloseModel}
                role={"button"}
                style={{ alignSelf: "end" }}
                class="fa-solid fa-xmark p-2"
              ></i>
              <h5
                className="py-2 text-center"
                style={{ color: Colors.Base_color, alignSelf: "center" }}
              >
                Are you sure want to logging out
              </h5>
              <div className="d-flex justify-content-center align-items pb-3 ">
                <button
                  className="btn mx-2"
                  style={{ backgroundColor: Colors.Base_color, color: "white" }}
                  onClick={handleLogOut}
                >
                  Yes
                </button>
                <button
                  className="btn mx-2"
                  style={{ backgroundColor: Colors.Base_color, color: "white" }}
                  onClick={handleCloseModel}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </Modal>
        <ToastContainer />
      </div>
      {/* <SearchCom
        display={display}
        setSearchVal={setSearchVal}
        searchVal={searchVal}
        clearSearch={clearSearch}
        callSearchFilter={callSearchFilter}
        onEnterFun={onEnterFun}
        srchRef={srchRef}
      /> */}

      <CateCom Category={Category} callFilter={callFilter} />
    </Fragment>
  );
}

export default Header;
